import pathname from './pathname'

export const DEFAULT_NAV_ITEMS = [
  {
    key: 'main',
    tip: 'หน้าหลัก',
    to: '/',
    icon: 'home',
  },
  {
    key: 'components',
    tip: 'ยื่นข้อเสนอโครงการ',
    to: '/proposal/select-proposal-form',
    icon: 'plus-square-o',
  },
  {
    key: 'download',
    tip: 'ดาวน์โหลดแบบฟอร์ม',
    to: pathname.formDownloads,
    icon: 'cloud-download',
  },
]

export const LOGIN_NAV_ITEMS = {
  key: 'sign-in',
  tip: 'เข้าใช้งานระบบ',
  to: pathname.dashboardRoot,
  icon: 'sign-in',
}

export const LOGOUT_NAV_ITEMS = {
  key: 'sign-out',
  tip: 'ออกจากระบบ',
  to: '/',
  icon: 'sign-out',
}

export const HEADER_CELL_WB = { whiteSpace: 'normal', wordBreak: 'break-word' }

export const TEMP_FORM_ID = 'formId'

export const SUB_PROJECT_ID = 'projectId' //'sub_projectId'
export const SUB_PROJECT_CODE = 'sub_projectCode'
export const SUB_FOLLOW_ID = 'follow_id'
export const SUB_FOLLOW_VM = 'follow_view_mode'

export const PROJECTID_FOR_SUB = 'projectforsub_id'

export const EMPTY_VALUE = (
  <>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</>
)
